import { useCallback, useEffect, useState } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { GetEcosystemUsageAction } from '@/application/actions';
import type { EcosystemUsageReportDTO } from '@/domain/repositories/IReportRepository';

export const useEcosystemUsage = (period?: string) => {
  const [report, setReport] = useState<EcosystemUsageReportDTO | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<GetEcosystemUsageAction>(TYPES.GetEcosystemUsageAction);
      setReport(await action.execute(period));
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to load ecosystem usage'));
    } finally {
      setIsLoading(false);
    }
  }, [period]);

  useEffect(() => {
    load();
  }, [load]);

  return { report, isLoading, error, refetch: load };
};
